<template>
    <Head>
        <title>Wakaf Pahang - Pembayaran tidak berjaya</title>
        <link rel="shortcut apple-touch-icon icon" :href="img_favicon" type="image/png">
    </Head>
    <div class="container">
        <div class="card mt-5 w-100">
            <div class="card-body">
                <div class="alert alert-danger">
                    <p class="fs-4 fw-bold text-center">Pembayaran Gagal</p>
                </div>
                <p class="card-text">Kami tidak menerima sebarang pembayaran daripada anda. Sila pastikan anda mengisi maklumat teleperbankan
                    anda
                    dengan betul. Sila klik butang <strong>"Cuba lagi"</strong> untuk membuat bayaran dan
                    <strong>"Batalkan"</strong>
                    untuk batal pembayaran serta maklumat pembayaran</p>
                <div class="d-flex justify-content-around">
                    <form ref="wrazer" method="post" :action="uridel">
                        <input type="hidden" name="_token" :value="tokenizer" />
                        <input type="hidden" name="_method" value="DELETE">
                        <button type="submit" class="btn btn-danger"><i class="fa-solid fa-xmark me-2"></i>Batalkan</button>
                    </form>
                    <form method="post" :action="uritry">
                        <input type="hidden" name="_token" :value="tokenizer" />
                        <button type="submit" class="btn btn-primary"><i class="fa-solid fa-money-bill me-2"></i> Cuba semula</button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import {onMounted, Ref, ref} from "vue";
import {Head} from "@inertiajs/vue3";
const wrazer = ref<HTMLFormElement>();
const data = defineProps<{
    img_favicon: string,
    uridel: string,
    uritry: string,
    tokenizer: string,
    razeripn: string,
}>();
onMounted(()=>{
    document.getElementsByTagName("body")[0].style.width = "100%";
    document.getElementsByTagName("body")[0].style.display = "grid";
    document.getElementsByTagName("body")[0].style.placeItems = "center";
    document.getElementsByTagName("html")[0].style.width = "100%";
    document.getElementsByTagName("html")[0].style.height = "100%";
    document.getElementsByTagName("body")[0].style.height = "100%";

    let m = document.createElement("IFRAME");
    m.setAttribute("src", data.razeripn);
    m.setAttribute("seamless", "seamless");
    m.setAttribute("width", String(0));
    m.setAttribute("height", String(0));
    m.setAttribute("frameborder", String(0));
    m.setAttribute("scrolling", "no");
    m.setAttribute("style", "border:none !important;");
    document.body.appendChild(m);
});
</script>
